export const USER_PROFILE_FETCH_SUCCESS = 'USER_PROFILE_FETCH_SUCCESS';
export const USER_PROFILE_FETCH_FAIL = 'USER_PROFILE_FETCH_FAIL';
